import {Offer, OFFER_PRICE_TYPES} from '@chekin/core';

const firstPrice = 0;
type FormatPriceProps = {
  priceType: Offer['price_type'];
  items: Offer['items'];
};
export const formatPrice =
  (currencySymbol: string) =>
  ({priceType, items}: FormatPriceProps) => {
    if (
      priceType === OFFER_PRICE_TYPES.single ||
      priceType === OFFER_PRICE_TYPES.multiple
    ) {
      return `${currencySymbol}${items[firstPrice].price}`;
    }

    return '';
  };

export const getPrice = ({price_type, items}: Offer) => {
  if (price_type === OFFER_PRICE_TYPES.single) {
    return Number(items[firstPrice].price);
  }
  return 0;
};

export const shouldShowPricePrefix = (items?: Offer['items']): boolean => {
  if (!items || items.length <= 1) return false;
  return true;
};
